/* ==========================================================
   FILTRO DE IMAGENS POR COR + TRADUÇÃO DE LABEL
   Estratégia em camadas:
     1) Filtra por prefixo de filename (preto*, rosa*, verde*, 2cores*)
     2) Se não achar, busca variantes via API e usa featured_image
   ========================================================== */
(function () {
  'use strict';

  var COLOR_TO_FILE_PREFIX = {
    'black': 'preto', 'negro': 'preto', 'preto': 'preto',
    'rose': 'rosa', 'rose-red': 'rosa', 'rosa': 'rosa', 'pink': 'rosa',
    'green': 'verde', 'light-green': 'verde', 'verde': 'verde',
    'verde-menta': 'verde', 'mint': 'verde', 'mint-green': 'verde',
    'greenblack': '2cores', 'green-black': '2cores',
    'rose-red-black': '2cores'
  };

  var COLOR_TRANSLATION = {
    'black': 'Negro', 'negro': 'Negro', 'preto': 'Negro',
    'rose': 'Rosa', 'rose red': 'Rosa', 'rosa': 'Rosa', 'pink': 'Rosa',
    'green': 'Verde', 'light green': 'Verde', 'verde': 'Verde',
    'verde menta': 'Verde', 'mint': 'Verde', 'mint green': 'Verde',
    'greenblack': 'Verde y Negro', 'green black': 'Verde y Negro',
    'leopard': 'Leopardo', 'leopard print': 'Leopardo',
    'leopard print black': 'Leopardo',
    'rose red black': 'Rosa y Negro',
    'light blue': 'Azul Claro', 'azul claro': 'Azul Claro',
    'navy blue': 'Azul Marino', 'navy': 'Azul Marino', 'azul marino': 'Azul Marino',
    'royal blue': 'Azul Rey', 'azul real': 'Azul Rey',
    'blue': 'Azul', 'azul': 'Azul',
    'white': 'Blanco', 'blanco': 'Blanco', 'branco': 'Blanco',
    'red': 'Rojo', 'rojo': 'Rojo', 'vermelho': 'Rojo',
    'yellow': 'Amarillo', 'amarillo': 'Amarillo',
    'purple': 'Morado', 'morado': 'Morado',
    'gray': 'Gris', 'grey': 'Gris', 'gris': 'Gris', 'cinza': 'Gris',
    'beige': 'Beige', 'bege': 'Beige',
    'orange': 'Naranja', 'naranja': 'Naranja', 'laranja': 'Naranja',
    'orange print': 'Estampado Naranja'
  };

  // Cache do produto buscado por handle
  var productCache = {};

  function handleize(s) {
    return (s || '').toString().toLowerCase().trim()
      .replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
  }

  function getFilePrefix(colorValue) {
    var h = handleize(colorValue);
    return COLOR_TO_FILE_PREFIX[h] || null;
  }

  function translateColor(colorValue) {
    var key = (colorValue || '').toString().toLowerCase().trim();
    return COLOR_TRANSLATION[key] || colorValue;
  }

  function getFileBaseName(url) {
    if (!url) return '';
    var name = url.split('?')[0].split('/').pop() || '';
    name = name.replace(/_\d+x\d*(?=\.[a-z]+$)/i, '');
    name = name.replace(/\.[a-z0-9]+$/i, '');
    return name.toLowerCase();
  }

  function imageMatchesPrefix(imgUrl, prefix) {
    if (!prefix) return true;
    var base = getFileBaseName(imgUrl);
    if (!base) return false;
    var re = new RegExp('^' + prefix + '[-_]?\\d', 'i');
    return re.test(base);
  }

  function getCurrentProductHandle() {
    var m = window.location.pathname.match(/\/products\/([a-z0-9-]+)/i);
    return m ? m[1].toLowerCase() : null;
  }

  function fetchProductData(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data) productCache[handle] = data;
        return data;
      })
      .catch(function () { return null; });
  }

  // === ESTRATÉGIA 1: filtro por prefixo de filename ===
  function filterByPrefix(colorValue) {
    var prefix = getFilePrefix(colorValue);
    if (!prefix) return false; // não tem prefixo mapeado

    var thumbs = document.querySelectorAll('.bs-gallery-thumb');
    if (!thumbs.length) return false;

    var mainImg = document.getElementById('bsMainImage');
    var firstVisible = null;
    var anyMatch = false;

    thumbs.forEach(function (t) {
      var imgUrl = t.dataset.img || (t.querySelector('img') && t.querySelector('img').src) || '';
      var match = imageMatchesPrefix(imgUrl, prefix);
      if (match) {
        t.classList.remove('bs-hidden');
        if (!firstVisible) firstVisible = t;
        anyMatch = true;
      } else {
        t.classList.add('bs-hidden');
        t.classList.remove('active');
      }
    });

    if (!anyMatch) {
      // Reverte: mostra todas
      thumbs.forEach(function (t) { t.classList.remove('bs-hidden'); });
      return false;
    }

    if (firstVisible) {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      firstVisible.classList.add('active');
      if (mainImg && firstVisible.dataset.img) mainImg.src = firstVisible.dataset.img;
    }
    return true;
  }

  // === ESTRATÉGIA 2: filtro por variantes do produto (API) ===
  function filterByVariants(colorValue) {
    var handle = getCurrentProductHandle();
    if (!handle) return;

    fetchProductData(handle).then(function (data) {
      if (!data || !data.variants) return;

      var target = (colorValue || '').toString().toLowerCase().trim();

      // Encontra IDs de imagens associadas a variantes com essa cor
      var matchedImageIds = {};
      var matchedFilenames = {};
      data.variants.forEach(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        var hasColor = opts.some(function (o) {
          return o && o.toString().toLowerCase().trim() === target;
        });
        if (!hasColor) return;
        if (v.featured_image && v.featured_image.id) {
          matchedImageIds[v.featured_image.id] = true;
          if (v.featured_image.src) {
            matchedFilenames[getFileBaseName(v.featured_image.src)] = true;
          }
        }
      });

      // Também busca em images[] cujo alt contenha a cor
      if (data.images) {
        data.images.forEach(function (imgSrc) {
          var base = getFileBaseName(typeof imgSrc === 'string' ? imgSrc : '');
          if (!base) return;
          if (base.indexOf(target) !== -1 || base.indexOf(handleize(colorValue)) !== -1) {
            matchedFilenames[base] = true;
          }
        });
      }

      // Se temos só 1 imagem matched (provavelmente só a featured), não filtra
      // (manter UX: usuário veria só 1 thumb)
      var totalMatched = Object.keys(matchedFilenames).length;
      if (totalMatched === 0) return; // sem informação suficiente

      var thumbs = document.querySelectorAll('.bs-gallery-thumb');
      var mainImg = document.getElementById('bsMainImage');
      var firstVisible = null;
      var anyVisible = false;

      thumbs.forEach(function (t) {
        var imgUrl = t.dataset.img || (t.querySelector('img') && t.querySelector('img').src) || '';
        var thumbBase = getFileBaseName(imgUrl);
        var match = matchedFilenames[thumbBase];
        if (match) {
          t.classList.remove('bs-hidden');
          if (!firstVisible) firstVisible = t;
          anyVisible = true;
        } else {
          t.classList.add('bs-hidden');
          t.classList.remove('active');
        }
      });

      if (!anyVisible) {
        thumbs.forEach(function (t) { t.classList.remove('bs-hidden'); });
        return;
      }

      if (firstVisible) {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        firstVisible.classList.add('active');
        if (mainImg && firstVisible.dataset.img) mainImg.src = firstVisible.dataset.img;
      }
    });
  }

  function filterThumbsByColor(colorValue) {
    // Tenta estratégia 1 (prefixo de filename)
    var ok = filterByPrefix(colorValue);
    if (ok) return;
    // Fallback: filtra por variantes da API
    filterByVariants(colorValue);
  }

  function updateColorLabel(colorValue) {
    document.querySelectorAll('.bs-option-group').forEach(function (group) {
      var hasColor = group.querySelector('.bs-color-swatch');
      if (!hasColor) return;
      var label = group.querySelector('.bs-option-selected');
      if (label) label.textContent = translateColor(colorValue);
    });
  }

  function handleSwatchClick(sw) {
    var value = sw.dataset.value || sw.dataset.colorHandle || sw.title || '';
    setTimeout(function () {
      filterThumbsByColor(value);
      updateColorLabel(value);
    }, 10);
  }

  function attachHandlers() {
    var swatches = document.querySelectorAll('.bs-color-swatch');
    swatches.forEach(function (sw) {
      if (sw.dataset.cpExtrasBound === '1') return;
      sw.dataset.cpExtrasBound = '1';
      sw.addEventListener('click', function () { handleSwatchClick(sw); });
    });
  }

  function initialRun() {
    attachHandlers();
    var active = document.querySelector('.bs-color-swatch.active');
    if (active) {
      var value = active.dataset.value || active.dataset.colorHandle || active.title || '';
      filterThumbsByColor(value);
      updateColorLabel(value);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialRun);
  } else {
    initialRun();
  }

  var observer = new MutationObserver(function () { attachHandlers(); });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  [400, 1000, 2500].forEach(function (ms) {
    setTimeout(function () { attachHandlers(); }, ms);
  });
})();
